import * as React from "react";
import { FC, useEffect } from "react";
import { Feature } from "ol";
import { useAppContext } from "../Contexts/AppContext";
import { RegistrationContextProvider } from "../Contexts/RegistrationContext";
import { Registration } from "../Registration/Registration";
import { fetchConfigJson, fetchFieldInfo } from "../Map/rest";
import { Info } from "../Popups/Info/Info";
import "../css/icons/style.css";
import "../css/map.scss";
import "ol/ol.css";

export interface IPubEventsMapProps {
    features: Feature[] | null;
    forceUpdate: number;
}

export const PubEventsMap: FC = () => {
    const { setConfigJson, setFieldInfos, info } = useAppContext();

    useEffect(() => {
        fetchConfigJson().then((json) => {
            console.log("configJson", json);
            setConfigJson(json);
        });
        fetchFieldInfo().then((fieldInfo) => setFieldInfos(fieldInfo));
    }, []);

    return (
        <RegistrationContextProvider>
            <Registration></Registration>
            {info ? <Info></Info> : null}
        </RegistrationContextProvider>
    );
};
